import React from "react";
import {getAssetPath} from "../../../../../../utils/get-asset-path.js";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const getAttachUrl = (attachId) => `${API_KEEPER}/ged/attach/${attachId}`;

const IndividualPhoto = ({individual, fullHeight = false, fromGrid = false}) => {
    if (!individual.relatedPhotoFaceId && !fromGrid) {
        return (
            <div className={`flex ${fullHeight ? "h-full" : "h-35"} items-center justify-center rounded border border-gray-200 bg-gray-100 text-sm font-semibold`}>
                [ SEM FOTO ]
            </div>
        );
    }

    return (
        <div className={`${fullHeight ? "h-full" : "h-35"} overflow-hidden rounded border border-gray-200 bg-gray-100`}>
            <img
                className="h-full w-full object-contain"
                src={getAttachUrl(individual.relatedPhotoFaceId)}
                alt={individual.name ?? "Foto do indivíduo"}
                onError={(e) => e.target.src = getAssetPath("img/user.png")}
            />
        </div>
    );
}

export default IndividualPhoto;